module.exports = {
      id: "table-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "sprite-dd6387.smartcharts.svg#table-usage",
      toString: function () {
        return this.url;
      }
    }